import { loginV1User } from "@/services/v1/authAPIService";
import {
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  setRefreshToken,
  removeAccessToken,
  removeRefreshToken,
} from "@/helpers/token";

export default {
  state: {
    errors: null,
    loading: false,
    accessToken: getAccessToken(),
    refreshToken: getRefreshToken(),
  },
  getters: {
    loginError: (state) => state.errors,
    isLoginLoading: (state) => state.loading,
    isAuthenticated: (state) => !!state.accessToken,
  },
  mutations: {
    SET_ERROR(state, error) {
      state.errors = error;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_TOKEN(state, token) {
      state.accessToken = token.access;
      state.refreshToken = token.refresh;
      setAccessToken(token.access);
      setRefreshToken(token.refresh);
    },
    CLEAR_AUTH(state) {
      state.accessToken = null;
      state.refreshToken = null;
      removeAccessToken();
      removeRefreshToken();
    },
  },
  actions: {
    async login({ commit }, credentials) {
      commit("SET_LOADING", true);
      try {
        const response = await loginV1User(credentials);
        commit("SET_TOKEN", response);
        commit("SET_ERROR", null);
      } catch (error) {
        const errorMessages = [];
        for (const [field, messages] of Object.entries(error)) {
          messages.forEach((message) => {
            console.log(`${field}: ${message}`);
            errorMessages.push(message);
          });
        }
        commit("SET_ERROR", errorMessages);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async logout({ commit }) {
      commit("CLEAR_AUTH");
    },
  },
};
